module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_3016.0509de9d.png";